import React from "react";
import DonateDonationsHistory from "../components/DonateDonationsHistory/DonateDonationsHistory";

function DonateDonationsHistoryPage() {
  return <DonateDonationsHistory />;
}

export default DonateDonationsHistoryPage;
